<template>
  <div class="home content mg-bo40">
    <div class="home-top">
      <slider animation="fade">
        <slider-item v-for="(i, index) in banner" :key="index" :style="i" @click="hello">
          <a :href="i.link" >
            <img :src="i.imageUrl" style="width:100%;height:100%;">
            <p style="line-height: 280px; font-size: 5rem; text-align: center;">Page{{ index + 1 }}</p>
          </a>
          <!-- <router-link :to="{path:i.link}" target="_blank">
            <img :src="i.imageUrl" style="width:100%;height:100%;">
            <p style="line-height: 280px; font-size: 5rem; text-align: center;">Page{{ index + 1 }}</p>
          </router-link> -->
        </slider-item>
      </slider>
    </div>
    <div class="home-text" style="margin-top:15px;">
      <div class="home-news d-flex">
        <div class="flex-auto" style="width:852px;">
          <div class="home-newsIn d-flex">
          <!-- 新闻公告 -->
            <div class="flex-auto home-newsIn-border" style="width:414px;">
              <div class="home-newsIn-top d-flex">
                <div class="flex-auto hnt-left font16">
                  <span></span>{{langTrans.news}}
                </div>
                <div class="hnt-right font12 cursor">
                    <router-link to="/news?type=1">{{langTrans.more}}>></router-link>
                </div>
              </div>
              <div class="home-newIn-center d-flex">
                <div class="flex-auto hnc-img">
                  <img :src="news.length == 0 ? '' : news[0].imageUrl" alt>
                </div>
                <div class="hnc-title">
                  <p class="font16">{{news.length == 0 ? langTrans.nodata : news[0].title}}</p>
                  <p class="font12">
                    <!-- <span>{{title | news[0].content}}....</span> -->
                    <span class="line_height23">{{(news.length == 0 ? langTrans.nodata : news[0].subhead) | limitWord(50)}}</span>
                    <router-link :to="'/detail?handler=getNewsDetail&filed=content&id='+news[0].id">[{{langTrans.detail}}]</router-link>
                  </p>
                </div>
              </div>
              <div class="home-newIn-bottom">
                <ul>
                  <li v-for="(item,index) in news" :key="index" class="font14">
                    <router-link :to="'/detail?handler=getNewsDetail&filed=content&id='+item.id" v-if="index != 0">
                      <span><i></i>{{item.title}}</span>
                      <!-- <span class="font10">[{{item.addTime | timeFormater}}]</span> -->
                      <span class="font14">[{{item.reportTime}}]</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          <!-- 社会责任 -->
            <div class="flex-auto home-newsIn-border response" style="width:414px;">
              <div class="home-newsIn-top d-flex">
                <div class="flex-auto hnt-left font16">
                  <span></span>{{langTrans.responsibility}}
                </div>
                <div class="hnt-right font12 cursor">
                  <router-link to="/responsibility?type=1" class>{{langTrans.more}}>></router-link>
                </div>
              </div>
              <div class="home-newIn-center d-flex">
                <div class="flex-auto hnc-img">
                  <img :src="commonwealnewsVos.length == 0 ? '' : commonwealnewsVos[0].imageUrl" alt>
                </div>
                <div class="hnc-title font14">
                  <p class="font16">{{commonwealnewsVos.length == 0 ? langTrans.nodata : commonwealnewsVos[0].title}}</p>
                  <!-- <p>
                    <span>{{(commonwealnewsVos.length == 0 ? '暂无' : commonwealnewsVos[0].subhead) | limitWord(150)}}</span>
                  </p> -->
                </div>
              </div>
              <div class="respons-bottom font14">
                <span>{{(commonwealnewsVos.length == 0 ? langTrans.nodata : commonwealnewsVos[0].subhead) | limitWord(150)}}</span>
                <router-link :to="'/detail?handler=getCommunityResponsDetail&filed=content&id='+commonwealnewsVos[0].id">[{{langTrans.detail}}]</router-link>
              </div>
            </div>
          </div>
          <div class="home-produce home-newsIn-border">
            <div class="home-newsIn-top d-flex">
              <div class="flex-auto hnt-left font16">
                <span></span>{{aboucompanyVo.title}}
              </div>
            </div>
            <div class="d-flex">
              <div class="produce-img flex-auto">
                <img :src="aboucompanyVo.imageUrl" alt>
              </div>
              <div class="produce-text font14 flex-auto">
                <span>{{aboucompanyVo.subhead | limitWord(150)}}</span>
                <router-link :to="'/about?type=1'">[{{langTrans.detail}}]</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="home-newsIn-border abProduce" style="float:right;">
          <div class="home-newsIn-top d-flex">
            <div class="flex-auto hnt-left font16">
              <span></span>{{langTrans.products}}
            </div>
            <div class="hnt-right font12 cursor">
              <router-link to='/products?type=1' class>{{langTrans.more}}>></router-link>
            </div>
          </div>
          <div class="abProduceIn">
            <ul>
              <li v-for="(item,index) in categoryList" :key="index" class="cursor">
                <router-link :to="'/products?type=' + item.id">
                  <img :src="item.length == 0 ? '' : item.iconUrl">
                  <span>{{item.length == 0 ? langTrans.nodata : item.name}}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="index_footer">
      <a :href="list.link" v-for="list in brandLinks" :key="list">
        <img :src="list.imageUrl" style="width:100%;height:auto;" />
      </a>
    </div>
  </div>
</template>
<script>
import { getIndex } from "@/api";
import {mapState} from 'vuex';
export default {
  name: "home",
  data() {
    return {
      langTrans:this.$store.state.langData.home,
      banner: [], //banner图
      news: [{id:''}], //新闻
      commonwealnewsVos:[{id:''}],//社会责任
      categoryList:[],//产品分类
      aboucompanyVo:{},//企业简介
      brandLinks:[],//底部链接图
      response:
        "2018年7月，国际劳工组织全球商业与残障网络-中国分支（以下简称“GBDN-中国”）在北京正式成立，安邦制药作为国际劳工组织全球商业与残障网络的中国分支创始单位之一，安邦制药董事长陈飞豹当选为该网络中国分支副主席。《超经济分析：“融合就业”与安邦制药模式》残障人士特殊价值人力",
      produce:
        "湖南安邦制药股份有限公司（以下简称安邦制药）创建于1994年，现已发展成为集两家制药工厂、一家商业平台、一家健康科技公司、两家医药生态服务企业以及省级院士工作站于一体的现代化医药集团，是国家高新技术企业、2018年中国十大最受尊敬企业和湖南省精准扶贫的样本。安邦制药深耕基层医疗市场，促进行业生态文明，公司打造了“渠道联盟+生态赋能”的安邦模式，掘金基层医疗万亿蓝海市场。目前已构筑覆盖全国100"
      
    };
  },
  methods: {
    hello($event) {
      
    }
  },
  filters: {
  },
  mounted() {
    getIndex().then(res => {
      (this.banner = res.data.banner)
      , (this.news = res.data.news)
      , (this.commonwealnewsVos = res.data.commonwealnewsVos)
      , (this.categoryList = res.data.categoryList)
      , (this.aboucompanyVo = res.data.aboucompanyVo)
      , (this.brandLinks = res.data.brandLinks)
    });
  }
};
</script>
<style lang="stylus">
.slider {
  height: 400px !important;
}

.home-newsIn-border {
  border: 1px solid #C6DAE2;
  padding-bottom: 22px;

  .home-newsIn-top {
    font-weight: bold;
    background: #F4FAFF;
    padding-bottom: 5px;

    .hnt-left {
      color: #1A3B82;
      margin: 7px 0 0 9px;

      span {
        display: inline-block;
        width: 6px;
        height: 24px;
        border-radius: 3px;
        background: #1A3B82;
        margin-right: 13px;
        vertical-align: text-top;
      }
    }

    .hnt-right {
      color: #1A3B82;
      line-height: 31px;
      margin-right: 15px;
      margin-top: 4px;
    }
  }

  .home-newIn-center {
    padding: 0 6px;
    margin-top: 15px;

    .hnc-img img {
      width: 174px;
      height: 130px;
    }

    .hnc-title {
      width: 216px;
      margin-left: 10px;

      p:nth-child(1) {
        width: 100%;
        line-height: 20px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      p:nth-child(2) {
        width: 100%;
        margin-top: 18px;
        color:#6b6b6b;
        span{
          line-height:20px;
        }
      }

      a {
        color: #E73939;
      }
    }
  }

  .home-newIn-bottom {
    margin-top: 5px;

    ul {
      padding: 0 19px 0 20px;

      li {
        line-height: 24px;
          color: #6b6b6b;
        span:nth-child(1) {
          width: 220px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 48px;
          vertical-align: middle;
          color:#000;
          i{
            display inline-block;
            width 5px;
            height 5px;
            background #1278c6;
            border-radius 50%;
            margin-right 5px;
            vertical-align: middle
          }
        }
        span:nth-child(1):hover{
          color:#e73939;
        }
      }
    }
  }

  .respons-bottom {
    margin-top: 5px;
    padding: 0 12px;
    line-height: 25px;
    color:#6b6b6b;
    a {
      color: #E73939;
    }
  }
}

.response {
  margin: 0 12px;
}

.home-produce {
  margin-top: 15px;
  margin-right: 12px;

  .produce-img {
    width: 426px;
    height: 205px;
    margin-left: 10px;
    margin-top: 14px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .produce-text {
    margin-top: 24px;
    padding: 0 12px;
    line-height: 25px;
    color:#6b6b6b;
    a {
      color: #E73939;
    }
  }
}

.abProduce {
  padding-bottom: 0;

  .abProduceIn {
    ul {
      li {
        position: relative;
        margin-bottom: 7.4px;
        width: 346px;
        height: 85px;

        img {
          width: 100%;
          height: 100%;
        }
      }
      li:last-child{
        margin-bottom:0;
      }

      span {
        font-size: 22px;
        font-weight: bold;
        position: absolute;
        top: 27px;
        right: 38px;
        color: #1A3B82;
      }
    }
  }
}
  .index_footer{
    width:1200px;
    margin:0 auto;
    overflow:hidden;
    padding-top:30px;
    display:flex;
    justify-content: space-between;
    flex-wrap: wrap;
    a{
      display:block;
      border-radius:10px;
      margin-right:2%;
      width:18.4%;
      span{
        font-size:16px;
      }
    }
    a:nth-child(5),a:nth-child(10){
      margin-right:0;
    }
  }
</style>